import React, { useState, useCallback } from "react";
import "./header.css";
import Icons from "../../config/images";
import { useNavigate, useLocation } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);

  const handleClick = (linkName, path) => {
    setActiveLink(path);
    navigate(path);
  };

  const onContactUs = useCallback(() => {
    setActiveLink("/contact-form");
    navigate("/contact-form");
  }, [navigate]);

  return (
    <div className="header-style">
      <nav className="navbar-section">
        <div className="navbar-flex-row-style">
          <img
            src={Icons.logo}
            alt="Office Work"
            className="logo-image-style"
            onClick={() => handleClick("Home", "/")}
          />
        </div>
        <ul className="nav-links">
          <li>
            <a
              href="#"
              className={`nav-link-text ${activeLink === "/" ? "active" : ""}`}
              onClick={() => handleClick("Home", "/")}
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="#"
              className={`nav-link-text ${activeLink === "/service" ? "active" : ""}`}
              onClick={() => handleClick("Services", "/service")}
            >
              Services
            </a>
          </li>
          <li>
            <a
              href="#"
              className={`nav-link-text ${activeLink === "/about" ? "active" : ""}`}
              onClick={() => handleClick("About Us", "/about")}
            >
              About Us
            </a>
          </li>
          <li>
            <a
              href="#"
              className={`nav-link-text ${activeLink === "/career" ? "active" : ""}`}
              onClick={() => handleClick("Careers", "/career")}
            >
              Careers
            </a>
          </li>
        </ul>
        <button className="contact-btn" onClick={onContactUs}>
          <span className="btn-text">Contact Us</span>
        </button>
      </nav>
    </div>
  );
};

export default Header;
